module.exports = __webpack_public_path__ + "static/media/shuffle.0507498d.png";